import Phaser from 'phaser';
import { GAME, RENDER_SCALE } from './config';

/**
 * Present the fixed logical 1024×640 layout on the supersampled canvas.
 *
 * The game canvas is created at GAME.width/height × RENDER_SCALE so the WebGL
 * backing store has enough pixels to look crisp on Retina displays. This zooms
 * the scene camera by the same factor and centres it on the logical play area,
 * so every scene can keep authoring against the original 1024×640 coordinates.
 *
 * Returns the logical size — call it at the top of each scene's create() in
 * place of `const { width, height } = this.scale`.
 */
export function presentLogical(scene: Phaser.Scene): { width: number; height: number } {
  const cam = scene.cameras.main;
  cam.setZoom(RENDER_SCALE);
  cam.centerOn(GAME.width / 2, GAME.height / 2);
  return { width: GAME.width, height: GAME.height };
}
